(function ($, Unison) {
  'use strict';

  Drupal.behaviors.artistry_artists_page_formatter_v1 = {
    attach: function (context) {
      // ids and classes we can refer to
      // data-filter-id - set on the form options
      // <option data-filter-id="mac--all" value="mac--all">All Regions</option>
      // <option data-filter-id="mac-region-term1" value="mac-region-term1">Africa</option>
      // artist-tile - on the artist element that also has one of the classes below
      // 'mac--all' => 'All Regions', // used as a label only
      // 'mac-region-term1' => 'Africa',
      // 'mac-region-term2' => 'Asia & Australia',
      // 'mac-region-term3' => 'Europe',
      // 'mac-region-term4' => 'India & Middle East',
      // 'mac-region-term5' => 'North America',
      // 'mac-region-term6' => 'South America',

      var $artistTile = $('.js-artist-tile', context); // there are many on the all artists page
      var $filterList = $('.js-region-filter');
      var $artistPager = $('.js-artists-pager', context); // pager link

      $filterList.on('change', function (e) {
        var filterClass = $(this).val();

        filterApply(filterClass);
      });
      $filterList.find('.sec-nav__sub-link').on('click', function (e) {
        e.preventDefault();
        var filterClass = $(this).attr('data-id');

        filterApply(filterClass);
        $filterList.find('.sec-nav__link span').html($(this).html());
      });
      function filterApply(filterClass) {
        $('.artistry-artist--paged:hidden').fadeIn('500').addClass('paged-show').matchHeight('remove');
        $artistPager.hide();
        if (filterClass === 'mac--all') {
          $artistTile.closest('.grid--item').fadeIn('500').addClass('filter-show').removeClass('filter-hide').matchHeight('remove');
          // Reapply matchHeight to ensure correct heights due to grid collapse
          $.fn.matchHeight._apply('.filter-show');
        } else {
          $('.js-artist-tile.' + filterClass).closest('.grid--item').fadeIn('500').addClass('filter-show').removeClass('filter-hide').matchHeight('remove');
          $artistTile.not('.artist-tile.' + filterClass).closest('.grid--item').fadeOut('500').addClass('filter-hide').removeClass('filter-show').matchHeight('remove');
          // Reapply matchHeight to ensure correct heights due to grid collapse
          $.fn.matchHeight._apply('.filter-show');
        }
      }

      // Remove/reapply matchHeight to ensure correct heights due to grid collapse
      $(window).resize(_.debounce(function () {
        $('.grid--item').matchHeight('remove');
        $.fn.matchHeight._apply('.filter-show');
      }, 300));

      var $filterContainer = $('.artistry-artists-page__filter-container', context);
      var insertLocation = '.artist-grid-formatter-v1';

      // Move the video filter based on breakpoint
      Unison.on('change', function (bp) {
        var bpWidth = parseInt(bp.width, 10);
        var usnLarge = parseInt(Unison.fetch.all()['usn-large'], 10);

        if (bpWidth < usnLarge) {
          $filterContainer.detach().insertBefore($(insertLocation, context));
        } else {
          $filterContainer.detach();
          $('.artistry-artists-page-formatter', context).prepend($filterContainer);
        }
      });
    } // attach
  };
})(jQuery, Unison);
